module.exports = __webpack_public_path__ + "img/alarm.c2835202.svg";